<template>
  <div>
    <!-- Header container for home links + breadcrumbs + search button -->
    <header>
      <div>
        <a href="https://www.servizioelettriconazionale.it">
          <img
            src="@/assets/images/SEN-logo--white.png"
            alt="Logo di Servizio Elettrico Nazionale"
          />
          <span class="visuallyhidden">{{
            labels.SEN_GUIDA_BACKTOSEN_LABEL
          }}</span>
        </a>

        <a class="backhome" href="/guida_bolletta" v-if="$mq === 'md' || $mq === 'lg'">
          {{ labels.SEN_GUIDA_BACKTOHOME_LABEL
          }}<span class="visuallyhidden">{{
            labels.SEN_GUIDA_BACKTOHOME_LABEL_EXTRA
          }}</span>
        </a>
      </div>
    </header>
    <!-- END Header container for home links + breadcrumbs + search button -->

    <!-- Mobile menu container (visible only on small devices) -->
    <div class="mobile-menu-container" v-if="$mq === 'sm'">
      <a class="backhome" href="/guida_bolletta">
        {{ labels.SEN_GUIDA_BACKTOHOME_LABEL
        }}<span class="visuallyhidden">{{
          labels.SEN_GUIDA_BACKTOHOME_LABEL_EXTRA
        }}</span>
      </a>

      <button
        type="button"
        class="toggle-mobile-menu-button"
        ref="toggleMobileMenuButton"
        :class="{ active: isMobileMenuVisible }"
        @click="toggleMobileMenu"
        :aria-label="
          isMobileMenuVisible
            ? labels.SEN_GUIDA_MOBILEMENU_CLOSE_LABEL
            : labels.SEN_GUIDA_MOBILEMENU_OPEN_LABEL
        "
      ></button>
      <div class="mobile-menu">
        <MobileList
          v-show="isMobileMenuVisible"
          @closeModal="isMobileMenuVisible = false"
        />
      </div>
    </div>
    <!-- END Mobile menu container (visible only on small devices) -->

    <!-- Breadcrumbs container -->
    <div class="breadcrumbs-container">
      <!-- Breadcrumbs -->
      <BreadcrumbsNavigation />
      <!-- END Breadcrumbs -->

      <!-- Search button (triggers the search modal opening) -->
      <button
        type="button"
        class="search-button"
        ref="searchButton"
        v-if="$mq === 'md' || $mq === 'lg'"
        @click="showModal"
      >
        {{ labels.SEN_GUIDA_SEARCH_BUTTON_LABEL }}
      </button>
      <!-- END Search button (triggers the search modal opening) -->
    </div>
    <!-- END Breadcrumbs container -->

    <!-- Main content -->
    <main id="main" :aria-hidden="this.isModalVisible">
      <section
        class="navigation cards"
        v-if="
          Object.values($route.query).length > 0 && ($mq === 'md' ||
          $mq === 'lg') &&
          ! $route.query.sorgente
        "
      >
        <ContentList
          v-for="(query, index) in Object.values($route.query)"
          :level="index"
          :key="index"
          layout="navigation"
        />
      </section>
      <div>
        <section class="content cards">
          <ContentList
            v-if="Object.keys($route.query).length == 0"
            :level="Object.values($route.query).length"
            layout="home"
          />

          <ContentList
            v-else-if="Object.keys($route.query).length == 1 && $route.query.sorgente"
            :level="0"
            layout="home"
          />

          <ContentList
            v-else
            :level="Object.values($route.query).length"
            layout="extended"
          />
        </section>

        <section class="image" v-show="$mq === 'md' || $mq === 'lg' || isMobileImageVisible">
          <ImagePanel />
        </section>
      </div>
    </main>
    <!-- END Main content -->

    <!-- Bottom bar (displays only on mobile) -->
    <div class="bottom-bar" v-if="$mq === 'sm'">
      <button
        type="button"
        class="search-button"
        ref="searchButton"
        @click="showModal"
      >
        {{ labels.SEN_GUIDA_SEARCH_BUTTON_LABEL }}
      </button>

      <button 
        type="button" 
        class="show-image-button"
        :class="{'active': isMobileImageVisible}"
        ref="showImageButton"
        @click="isMobileImageVisible = !isMobileImageVisible">
        {{ 
          isMobileImageVisible ? 
            labels.SEN_GUIDA_CLOSE_IMAGE_BUTTON_LABEL :
            labels.SEN_GUIDA_SHOW_IMAGE_BUTTON_LABEL
        }}
      </button>
    </div>
    <!-- END Bottom bar (displays only on mobile) -->

    <SearchModal
      v-show="isModalVisible"
      @close="closeModal"
      :visible="isModalVisible"
    >
    </SearchModal>
  </div>
</template>

<script>
import ContentList from "./components/ContentList";
import BreadcrumbsNavigation from "./components/BreadcrumbsNavigation.vue";
import ImagePanel from "./components/ImagePanel.vue";
import SearchModal from "./components/SearchModal.vue";
import MobileList from "./components/MobileList.vue";
import labels from "@/data/labels.json";
import "@/assets/css/style.css";
import "@/assets/css/fonts.css";

export default {
  name: "App",
  components: {
    ContentList,
    BreadcrumbsNavigation,
    ImagePanel,
    SearchModal,
    MobileList,
  },
  data() {
    return {
      isModalVisible: false,
      isMobileImageVisible: false,
      isMobileMenuVisible: false,
      labels,
    };
  },
  methods: {
    showModal() {
      // preventing overflow on body
      document.body.classList.add("modal-open");
      this.isModalVisible = true;
    },
    closeModal() {
      document.body.classList.remove("modal-open");
      this.isModalVisible = false;

      this.$refs.searchButton.focus();
    },
    toggleMobileMenu() {
      this.isMobileMenuVisible = !this.isMobileMenuVisible;
    },
  },
};
</script>
<style lang="scss"></style>
